import { KeycloakOptions } from "keycloak-angular";
import { AbstractEnvironment } from "@biorec/common";

export class Environment extends AbstractEnvironment {
	
	static override readonly production = false; // else patterns will not compile
	static override readonly backendUrl = 'https://api2.biorec.org/partners';
	
	static override readonly keycloakOptions = {
		config: {
			url: 'https://partners.mikroskopisi.gr/auth',
			realm: 'mikroskopisi-partners',
			clientId: 'partners-frontend',
		},
		initOptions: {
			onLoad: 'check-sso',
			silentCheckSsoRedirectUri: window.location.origin
				+ window.location.pathname.replace(/^(\/[a-z]{2})($|\/.*)/, '$1')
				+ '/assets/check-sso.html',
		},
		loadUserProfileAtStartUp: false,
		bearerExcludedUrls: []
	 } as KeycloakOptions;
};
